import convertToCurrency from '~/utils/convertToCurrency'
import { addHours, formatDistanceToNow } from 'date-fns'
import useTranslator from '~/lib/useTranslator'

type Supporter = {
  _id: string
  type: 'donation' | 'products'
  emoji: string
  name: string
  amount: number
  createdAt: string | Date
}

export default function SupporterList(params: {
  locale?: string
  currency?: string
  supporters?: Supporter[]
  slug?: string
}) {
  const Translator = useTranslator()

  const supporters = params.slug === 'demo' ? demoPurchases : params.supporters || []

  return (
    <div className="bg-white">
      <section
        aria-labelledby="supporters-heading"
        className="flex flex-col items-center gap-2 py-12 w-full max-w-screen-lg mx-auto"
      >
        <h4 id="supporters-heading" className="font-normal ">
          {Translator.singular('My recent supporters ({{ count }})', {
            count: supporters.length.toString() || '0',
          })}
        </h4>
        <ul className="flex flex-col  max-w-6xl px-4 pt-4 gap-4 ">
          {supporters.map((p) => {
            return (
              <li
                className="inline-flex items-start gap-4 p-4 bg-gray-100 rounded-lg"
                key={p._id.toString()}
              >
                <p
                  className="text-neutral-900 font-medium pb-4 text-3xl"
                  role="img"
                  aria-label="Support level indicator"
                >
                  {p.emoji}
                </p>
                <div className="items-center">
                  <div className="flex flex-grow flex-col justify-center">
                    <span className="text-neutral-900 font-normal">
                      <strong className="text-neutral-900 font-medium">
                        {p.type === 'products'
                          ? Translator.singular('New sale from {{ name }}!', {
                              name: p.name || 'Anonymous',
                            })
                          : Translator.singular('New donation from {{ name }}!', {
                              name: p.name || 'Anonymous',
                            })}
                      </strong>{' '}
                      {Translator.singular('An order of')}{' '}
                      <strong>
                        {convertToCurrency(
                          params.locale,
                          params.currency,
                          (p.amount ?? 0) * 100,
                          2
                        )}
                      </strong>{' '}
                      {Translator.singular('has been placed.')}
                    </span>
                  </div>
                  <time
                    className="text-neutral-500 text-sm pb-4"
                    dateTime={
                      typeof p.createdAt === 'string' ? p.createdAt : p.createdAt.toISOString()
                    }
                  >
                    {formatDistanceToNow(p.createdAt, { addSuffix: true })}
                  </time>
                </div>
              </li>
            )
          })}
        </ul>
      </section>
    </div>
  )
}

// TODO(@kentos): how do we handle this differently for donations vs products?
const demoPurchases: Supporter[] = [
  {
    emoji: '🍿',
    _id: '1',
    type: 'products',
    name: 'John',
    createdAt: new Date().toISOString(),
    amount: 39.98,
  },
  {
    emoji: '🤠',
    type: 'products',
    _id: '2',
    name: 'Jane Doe',
    createdAt: addHours(new Date(), -1).toISOString(),
    amount: 200,
  },
]
